'use es6';

import { bindAll } from 'underscore';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { List, Map as ImmutableMap } from 'immutable';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { List as FoundationsList } from 'foundations-components/transitional/components/List';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { SuccessIcon, InfoIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Image } from 'foundations-components/transitional/components/Image';
import { Popover, PopoverCloseButton } from 'foundations-components/transitional/components/Popover';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { Text } from 'foundations-components/components/Text';
import copyImage from 'bender-url!page-editor-ui/img/mab/copy.gif';
import ctaImage from 'bender-url!page-editor-ui/img/mab/cta.gif';
import mediaImage from 'bender-url!page-editor-ui/img/mab/media.gif';
import layoutImage from 'bender-url!page-editor-ui/img/mab/layout.gif';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TABS = List.of('cta', 'copy', 'media', 'layout');
const IMAGES = ImmutableMap({
  copy: copyImage,
  cta: ctaImage,
  layout: layoutImage,
  media: mediaImage
});
const MORE_INFO_LINKS = ImmutableMap({
  copy: 'https://blog.hubspot.com/marketing/write-compelling-copy-tips',
  cta: 'https://knowledge.hubspot.com/cta-user-guide-v2/call-to-action-best-practices',
  layout: 'https://blog.hubspot.com/marketing/write-compelling-copy-tips',
  media: 'https://blog.hubspot.com/marketing/stock-photography-authentic-imagery'
});
const BULLET_POINTS = ImmutableMap({
  copy: List.of('clearAndCompelling', 'helpful', 'organized'),
  cta: List.of('easyToSpot', 'actionOriented', 'easyToUnderstand'),
  layout: List.of('valueFocused', 'logical', 'uncluttered'),
  media: List.of('highQuality', 'authentic', 'optimized')
});
const langKey = suffix => `components.bestPracticesPopover.${suffix}`;
export default class BestPracticesPopover extends PureComponent {
  constructor(props) {
    super(props);
    this.handleSkip = () => this.setState({
      openInitialPopover: false
    });
    this.handleShowMeHow = () => this.setState({
      openInitialPopover: false,
      openTips: true
    });
    this.handleOpenTips = () => this.setState({
      openTips: true
    });
    this.handleCloseTips = () => this.setState({
      openTips: false
    });
    this.handleToggleTips = () => this.setState(({
      openTips
    }) => ({
      openTips: !openTips
    }));
    this.renderTab = key => /*#__PURE__*/_jsxs(Tab, {
      tabId: key,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey(`${key}.title`)
      }),
      children: [/*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        marginBlock: "800",
        marginInline: "auto",
        children: /*#__PURE__*/_jsx(Image, {
          responsive: false,
          src: IMAGES.get(key),
          inlineSize: "200px"
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey(`${key}.body`)
        })
      }), /*#__PURE__*/_jsx(FoundationsList, {
        paddingBlock: "200",
        paddingInline: "0",
        wrapChildren: true,
        children: BULLET_POINTS.get(key).map(msgKey => `${key}.list.${msgKey}`).map(langKey).map(this.renderListItem)
      }), /*#__PURE__*/_jsx(Link, {
        external: true,
        href: MORE_INFO_LINKS.get(key),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey(`${key}.link`)
        })
      })]
    }, key);
    bindAll(this, 'handleSkip', 'handleShowMeHow', 'renderTab');
    this.state = {
      openInitialPopover: props.showInitialPopover,
      openTips: false
    };
  }
  renderListItem(message) {
    return /*#__PURE__*/_jsx(MediaObject, {
      alignItems: "flex-start",
      itemLeft: /*#__PURE__*/_jsx(IconCircle, {
        backgroundColor: "fill-positive-pressed",
        color: "icon-core-on-fill-default",
        icon: SuccessIcon,
        marginBlockStart: "50",
        padding: "100",
        size: "100"
      }),
      paddingBlock: "100",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: message
        })
      })
    }, message);
  }
  renderIcon() {
    return /*#__PURE__*/_jsx(IconHolder, {
      icon: InfoIcon,
      color: "icon-core-subtle",
      onClick: this.handleToggleTips
    });
  }
  renderInitialPopover() {
    const {
      mabMetric,
      test
    } = this.props;
    const bodyLangKey = test === 'ab' ? 'initialPopover.body.ab' : `initialPopover.body.${test}.${mabMetric}`;
    return /*#__PURE__*/_jsx(Popover, {
      content: {
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey(bodyLangKey)
        }),
        footer: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Button, {
            use: "primary",
            onClick: this.handleShowMeHow,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: langKey('initialPopover.buttons.confirm')
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: this.handleSkip,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: langKey('initialPopover.buttons.cancel')
            })
          })]
        }),
        header: /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('initialPopover.header')
          })
        })
      },
      open: this.state.openInitialPopover,
      inlineSize: "360px",
      placement: "bottom right",
      use: "shepherd",
      children: this.renderIcon()
    });
  }
  renderPopover() {
    return /*#__PURE__*/_jsx(Popover, {
      content: {
        body: /*#__PURE__*/_jsx(Tabs, {
          defaultSelected: "cta",
          fill: true,
          children: TABS.map(this.renderTab)
        }),
        header: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h3", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: langKey('headingText')
            })
          }), /*#__PURE__*/_jsx(PopoverCloseButton, {
            color: "icon-core-subtle",
            onClick: this.handleCloseTips,
            size: "md"
          })]
        })
      },
      closeOnOutsideClick: true,
      onOpenChange: this.handleCloseTips,
      open: this.state.openTips,
      placement: "bottom right",
      use: "longform",
      maxInlineSize: "450px",
      children: this.renderIcon()
    });
  }
  render() {
    if (this.state.openInitialPopover) {
      return this.renderInitialPopover();
    }
    return this.renderPopover();
  }
}
BestPracticesPopover.propTypes = {
  mabMetric: PropTypes.string,
  showInitialPopover: PropTypes.bool,
  test: PropTypes.oneOf(['ab', 'mab'])
};